import { IconProps } from '../iconProps';

export const IdCard = ({ size = 24, fill = '' }: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill={fill}
      stroke='currentColor'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
      className='lucide lucide-id-card-icon lucide-id-card'
    >
      <path d='M16 10h2' />
      <path d='M16 14h2' />
      <path d='M6.17 15a3 3 0 0 1 5.66 0' />
      <circle
        cx='9'
        cy='11'
        r='2'
      />
      <rect
        x='2'
        y='5'
        width='20'
        height='14'
        rx='2'
      />
    </svg>
  );
};
